import { atom, selector } from 'recoil'

import type { PanelConfigColumnsState } from 'Pages/RecipientsList/model'

export const panelConfigColumnsState = atom<PanelConfigColumnsState>({
  key: 'recipientsList_panelConfigColumnsState',
  default: {
    show: false,
    items: [],
  },
})

export const panelConfigColumnsCanSaveState = selector<boolean>({
  key: 'recipientsList_panelConfigColumnsCanSaveState',
  get: ({ get }) => {
    const { items } = get(panelConfigColumnsState)

    const definedColumns = items.filter((o) => o !== undefined)

    return definedColumns.length > 0
  },
})
